import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ParsedItemIndexReferenceWrapper } from '../parse-models';
import { parserConfiguration } from '../parser-configuration';
import { parserHelper } from '../parser.helper';
export var AsyncBrowserParser =
/*#__PURE__*/
function () {
  function AsyncBrowserParser() {
    _classCallCheck(this, AsyncBrowserParser);
  }

  _createClass(AsyncBrowserParser, [{
    key: "parseAsync",
    value: function parseAsync(html, mainRichTextElement, resolvers, linkedItems) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.parseInternalAsync(mainRichTextElement, resolvers, html, linkedItems, new ParsedItemIndexReferenceWrapper(0), null);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "parseInternalAsync",
    value: function parseInternalAsync(mainRichTextElement, resolvers, html, linkedItems, linkedItemIndex, parentElement) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var rootElement, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rootElement = this.createWrapperElement(html); // get all linked items

                _context2.next = 3;
                return this.processRichTextElementAsync(mainRichTextElement, resolvers, rootElement.children, {
                  links: [],
                  linkedItems: [],
                  images: []
                }, linkedItems, linkedItemIndex, parentElement);

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", {
                  componentCodenames: result.linkedItems.filter(function (m) {
                    return m.itemType === 'component';
                  }).map(function (m) {
                    return m.dataCodename;
                  }),
                  linkedItemCodenames: result.linkedItems.filter(function (m) {
                    return m.itemType === 'linkedItem';
                  }).map(function (m) {
                    return m.dataCodename;
                  }),
                  result: rootElement.innerHTML
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "processRichTextElementAsync",
    value: function processRichTextElementAsync(mainRichTextElement, resolvers, htmlCollection, result, linkedItems, linkedItemIndex, parentElement) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var i, element, typeAttribute, dataCodenameAttribute, dataTypeAttribute, relAttribute, itemType, linkItemContentObject, elementParent, dataItemIdAttribute, linkObject, linkText, dataImageIdAttribute, imageObj;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!htmlCollection || htmlCollection.length === 0)) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 59;
                break;

              case 3:
                i = 0;

              case 4:
                if (!(i < htmlCollection.length)) {
                  _context3.next = 59;
                  break;
                }

                element = htmlCollection[i];
                resolvers.elementResolverAsync(parserHelper.convertToParserElement(element));
                typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined; // process linked items (modular items)

                if (!(element.attributes && typeAttribute && typeAttribute.value && typeAttribute.value.toLowerCase() === parserConfiguration.modularContentElementData.type.toLowerCase())) {
                  _context3.next = 32;
                  break;
                }

                dataCodenameAttribute = element.attributes.getNamedItem(parserConfiguration.modularContentElementData.dataCodename);
                dataTypeAttribute = element.attributes.getNamedItem(parserConfiguration.modularContentElementData.dataType);

                if (dataTypeAttribute) {
                  _context3.next = 13;
                  break;
                }

                throw Error('Missing data type attribute. This is likely an error caused by invalid response.');

              case 13:
                relAttribute = element.attributes.getNamedItem(parserConfiguration.modularContentElementData.relAttribute);
                itemType = 'linkedItem';

                if (relAttribute && relAttribute.value === parserConfiguration.modularContentElementData.componentRel) {
                  itemType = 'component';
                } // prepare link item object


                linkItemContentObject = {
                  dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
                  dataType: dataTypeAttribute ? dataTypeAttribute.value : '',
                  itemType: itemType
                }; // replace html

                elementParent = element.parentElement;

                if (elementParent) {
                  _context3.next = 22;
                  break;
                }

                console.warn("Could not replace linked item '".concat(linkItemContentObject.dataCodename, "' of '").concat(linkItemContentObject.dataType, "' because parent node is undefined. Please report this error if you are seeing this."));
                _context3.next = 30;
                break;

              case 22:
                if (!(dataTypeAttribute.value === 'item')) {
                  _context3.next = 29;
                  break;
                }

                // add to result
                result.linkedItems.push(linkItemContentObject); // resolve linked item

                _context3.next = 26;
                return resolvers.contentItemResolverAsync(parserHelper.convertToParserElement(element), linkItemContentObject.dataCodename, linkedItemIndex.index, parserHelper.getLinkedItem(linkedItems, linkItemContentObject.dataCodename));

              case 26:
                // increment index
                linkedItemIndex.increment();
                _context3.next = 30;
                break;

              case 29:
                console.warn("Rich text element contains object with unsupported data type '".concat(dataTypeAttribute.value, "'"));

              case 30:
                _context3.next = 53;
                break;

              case 32:
                if (!(element.nodeName.toLowerCase() === parserConfiguration.linkElementData.nodeName.toLowerCase())) {
                  _context3.next = 42;
                  break;
                }

                dataItemIdAttribute = element.attributes.getNamedItem(parserConfiguration.linkElementData.dataItemId);

                if (!dataItemIdAttribute) {
                  _context3.next = 40;
                  break;
                }

                linkObject = {
                  dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
                }; // add to result

                result.links.push(linkObject); // get original link text (the one inside <a> tag)

                linkText = element.innerHTML;
                _context3.next = 40;
                return resolvers.urlResolverAsync(parserHelper.convertToParserElement(element), linkObject.dataItemId, linkText, parserHelper.tryGetLink(mainRichTextElement, linkedItems, linkObject.dataItemId));

              case 40:
                _context3.next = 53;
                break;

              case 42:
                if (!(element.nodeName.toLowerCase() === parserConfiguration.imageElementData.nodeName.toLowerCase())) {
                  _context3.next = 51;
                  break;
                }

                dataImageIdAttribute = element.attributes.getNamedItem(parserConfiguration.imageElementData.dataImageId); // continue only if data image id is present. There could be regular img tags included

                if (!dataImageIdAttribute) {
                  _context3.next = 49;
                  break;
                }

                imageObj = {
                  imageId: dataImageIdAttribute.value
                };
                result.images.push(imageObj); // resolve image

                _context3.next = 49;
                return resolvers.imageResolverAsync(parserHelper.convertToParserElement(element), imageObj.imageId, parserHelper.tryGetImage(mainRichTextElement, linkedItems, imageObj.imageId));

              case 49:
                _context3.next = 53;
                break;

              case 51:
                _context3.next = 53;
                return resolvers.genericElementResolverAsync(parserHelper.convertToParserElement(element));

              case 53:
                if (!(element.children && element.children.length > 0)) {
                  _context3.next = 56;
                  break;
                }

                _context3.next = 56;
                return this.processRichTextElementAsync(mainRichTextElement, resolvers, element.children, result, linkedItems, linkedItemIndex, parentElement);

              case 56:
                i++;
                _context3.next = 4;
                break;

              case 59:
                return _context3.abrupt("return", result);

              case 60:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "createWrapperElement",
    value: function createWrapperElement(html) {
      var element = document.createElement(parserConfiguration.linkedItemWrapperElem);
      element.innerHTML = html;
      return element;
    }
  }]);

  return AsyncBrowserParser;
}();
export var asyncBrowserParser = new AsyncBrowserParser();